import { render, staticRenderFns } from "./ChatBubbleIcon.vue?vue&type=template&id=76649307&scoped=true"
import script from "./ChatBubbleIcon.vue?vue&type=script&lang=js"
export * from "./ChatBubbleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76649307",
  null
  
)

export default component.exports